import React, { useEffect } from 'react';
import './Homepage.css';
import Footer from './components/Footer/Footer';
import ContactForm from './components/ContactForm/ContactForm';
import InnovationSection from './components/Innovation/Innovation';

// Images
import bannerBg from './assets/images/main-banner -new.png';
import rightBannerImage from './assets/images/PULSOJET03.png';
import ZenProductSection from './components/ZenProductSection/ZenProductSection';

function Homepage() {
  useEffect(() => {
    document.title = "PulsOjet® - India's First Indigenous & Patented Pulse Lavage System";
  }, []);

  return (
    <div className="sabiote-homepage">

      {/* Banner Section */}
      <div className="banner-wrpper-max" style={{ backgroundImage: `url(${bannerBg})` }}>
        <section className="banner">
          <div className="banner-overlay">
            <div className="banner-content">
              <div className="banner-text">
                <h1>
                  India's First Indigenous{' '}
                  <span className="line-break line-breaking-box">& Patented Pulse Lavage System</span>
                </h1>
                <p>
                  <span className="line-break">
                    Engineered for Precision. Built for Surgeons.
                  </span>
                </p>
              </div>
            </div>
            <div className="banner-sidebar">
              <img src={rightBannerImage} alt="Right Banner Device" />
            </div>
          </div>
        </section>
      </div>

      {/* Innovation Story Section */}
      <InnovationSection />

      {/* How It Works Section */}
      <ZenProductSection />

      <ContactForm />
    </div>
  );
}

export default Homepage;
